<template>
  <v-container
    v-if="items !== null"
    grid-list-xl
    ref="containerb"
    id="containerb"
  >
    <br />
    <v-layout row wrap>
      <v-flex xs12>
        <v-card :elevation="2" :loading="loading" :disabled="loading">
          <v-card-title>Administración de planes nacionales</v-card-title>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="buscanacional"
              append-icon="search"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-card-text active-class="deep-purple accent-4 white--text">
            <v-flex xs12 sm12>
              <v-data-table
                :headers="headernacionales"
                :items="items"
                class="elevation-1"
                :no-data-text="gnodata"
                :no-results-text="gnosearch"
                :items-per-page="10"
                :search="buscanacional"
              >
                <template v-slot:top>
                  <v-toolbar>
                    <v-toolbar-title
                      >Lista de planes nacionales</v-toolbar-title
                    >
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          x-large
                          v-on="on"
                          @click="newpersona"
                          v-scroll-to="'#containera'"
                        >
                          <v-icon color="primary">add</v-icon>
                        </v-btn>
                      </template>
                      <span>Agregar</span>
                    </v-tooltip>
                  </v-toolbar>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        small
                        class="mr-2"
                        @click="grideditnacional(item)"
                        v-scroll-to="'#containera'"
                        >edit</v-icon
                      >
                    </template>
                    <span>Editar</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        small
                        class="mr-2"
                        v-show="item.eliminar"
                        @click="eliminarnacional(item)"
                        >mdi-delete</v-icon
                      >
                    </template>
                    <span>Eliminar</span>
                  </v-tooltip>
                </template>
                <template v-slot:footer>
                  <div id="div1" style="width: 100%; align: right">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <download-excel
                          id="div2"
                          style="width: 100%; text-align: right"
                          v-show="items.length > 0"
                          class="btn btn-default"
                          :data="items"
                          :exportFields="exportable"
                          name="nacionales.xls"
                          type="xls"
                          worksheet="Información"

                        >
                          <v-icon
                            color="secondary"
                            v-on="on"
                            large
                            elevation="2"
                            >mdi-file-download-outline</v-icon
                          >
                        </download-excel>
                      </template>
                      <span>Descargar</span>
                    </v-tooltip>
                  </div>
                </template>
              </v-data-table>
              <v-divider></v-divider>
            </v-flex>
          </v-card-text>

          <v-tabs
            show-arrows
            next-icon="fa-caret-right"
            prev-icon="fa-caret-left"
            background-color="blue-grey lighten-4"
            horizontal
            v-show="framenacional"
            id="containera"
            ref="containera"
          >
            <v-tabs-slider></v-tabs-slider>
            <v-tab> <v-icon left>folder</v-icon>Datos básicos </v-tab>
            <v-tab> <v-icon left>work</v-icon>Estrategias </v-tab>
            <v-tab-item>
              <form data-vv-scope="form-1">
                <v-card>
                  <v-card-title>Edición de plan nacional</v-card-title>
                  <v-card-text>
                    <v-flex row wrap>
                      <v-flex sm12 xs12>
                        <v-textarea
                          v-model="nacional.nombre"
                          label="Nombre: *"
                          :counter="200"
                          v-validate="'required|max:200'"
                          data-vv-name="nombrefuncionario"
                          :error-messages="errors.collect('nombrefuncionario')"
                        ></v-textarea>
                      </v-flex>
                      <v-flex sm12 xs12>
                        <v-textarea
                          v-model="nacional.descripcion"
                          label="Descripción: *"
                          :counter="1000"
                          v-validate="'required|max:1000'"
                          data-vv-name="descripcion"
                          :error-messages="errors.collect('descripcion')"
                        ></v-textarea>
                      </v-flex>
                      <v-flex sm6 xs6>
                        <v-select
                          label="Sector: *"
                          item-text="nombre"
                          v-validate="'required'"
                          data-vv-name="sector"
                          :error-messages="errors.collect('sector')"
                          :items="gsectores"
                          return-object
                          v-model="sector"
                        ></v-select>
                      </v-flex>
                      <v-flex sm6 xs6>
                        <v-select
                          label="Entidad: *"
                          item-text="nombre"
                          :items="gentidades"
                          return-object
                          v-model="entidad"
                          v-validate="'required'"
                          data-vv-name="entidad"
                          :error-messages="errors.collect('entidad')"
                        ></v-select>
                      </v-flex>
                      <v-flex sm12 xs12>
                        <v-textarea
                          v-model="nacional.objetivo"
                          label="Objetivo: *"
                          v-validate="'required|max:1000'"
                          :counter="1000"
                          data-vv-name="objetivo"
                          :error-messages="errors.collect('objetivo')"
                        ></v-textarea>
                      </v-flex>
                      <v-flex sm12 xs12>
                        <!-- <v-textarea
                          v-model="nacional.especificos"
                          label="Objetivos específicos: *"
                          v-validate="'required|max:2000'"
                          :counter="2000"
                          data-vv-name="especificos"
                          :error-messages="errors.collect('especificos')"
                        ></v-textarea> -->
                        <label for="objetivosespecificos" class="form-label">Objetivos específicos: *</label>
                        <quill-editor
                          ref="objetivosespecificos"
                          id="objetivosespecificos"
                           v-model="nacional.especificos"
                          :error-messages="errors.collect('especificos')"
                          :options="editorOptions"
                          @ready="onEditorReady($event)"
                          @change="onEditorChange($event)"
                        />
                        <div id="counter" class="counter"></div>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field
                          v-model="nacional.inicio"
                          label="Fecha inicio: *"
                          v-validate="'required'"
                          data-vv-name="agnoinicio"
                          :error-messages="errors.collect('agnoinicio')"
                          type="number"
                          min="2017"
                          max="2050"
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs12 sm6>
                        <v-text-field
                          v-model="nacional.fin"
                          label="Fecha fin: *"
                          v-validate="'required'"
                          data-vv-name="agnofin"
                          :error-messages="errors.collect('agnofin')"
                          type="number"
                          min="2017"
                          max="2050"
                        ></v-text-field>
                      </v-flex>
                      <v-flex sm12 xs12>
                        <v-divider :inset="false"></v-divider>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-color-picker
                          v-model="nacional.color"
                          v-validate="'required'"
                          data-vv-name="color"
                          :error-messages="errors.collect('color')"
                        ></v-color-picker>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field
                          v-model="nacional.color"
                          v-validate="'required'"
                          data-vv-name="color"
                          :error-messages="errors.collect('color')"
                          readonly
                        ></v-text-field>
                      </v-flex>
                      <v-flex sm12 xs12>
                        <v-divider :inset="false"></v-divider>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-file-input
                          accept=".jpeg, .png"
                          v-model="fileimagen"
                          show-size
                          label="Cargar archivo de imagen"
                          @change="onimagechange"
                        ></v-file-input>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <img
                          width="240px"
                          class="mx-auto d-block"
                          v-bind:src="baseimagen"
                        />
                      </v-flex>
                      <v-flex sm12 xs12>
                        <v-divider :inset="false"></v-divider>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-file-input
                          accept=".pdf"
                          v-model="filearchivo"
                          show-size
                          label="Cargar archivo de plan aprobado"
                          @change="onaprobadochange"
                        ></v-file-input>
                      </v-flex>
                      <v-flex xs12 sm6 v-if="basearchivo">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-btn v-on="on" @click="descargarsoporte"
                              >Descargar plan aprobado</v-btn
                            >{{ nacional.nombrearchivo }}
                          </template>
                          <span>{{ nacional.nombrearchivo }}</span>
                        </v-tooltip>
                      </v-flex>
                    </v-flex>
                  </v-card-text>
                  <v-card-actions>
                    <br />
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          class="mx-1"
                          v-on="on"
                          color="blue darken-1"
                          @click="cerrarrollocal"
                          v-scroll-to="'#containerb'"
                        >
                          <div class="text-white">Cancelar</div>
                        </v-btn>
                      </template>
                      <span>Cancelar</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          class="mx-1"
                          v-on="on"
                          color="blue darken-1"
                          @click="preventguardar"
                        >
                          <div class="text-white">Guardar</div>
                        </v-btn>
                      </template>
                      <span>Guardar</span>
                    </v-tooltip>
                  </v-card-actions>
                </v-card>
              </form>
            </v-tab-item>
            <v-tab-item>
              <v-card id="containerd" ref="containerd">
                <v-card-title>Edición de plan nacional - {{nacional.nombre}}</v-card-title>
                <v-card-text>
                  <v-flex xs12 sm12>
                    <v-data-table
                      :headers="headerestrategia"
                      :items="estrategias"
                      class="elevation-1"
                      :no-data-text="gnodata"
                      :no-results-text="gnosearch"
                      :items-per-page="10"
                    >
                      <template v-slot:[`item.activo`]="{ item }">
                        <div v-if="item.activo === true">
                          <span small class="mr-2">Sí</span>
                        </div>
                        <div v-else>
                          <span small class="mr-2">No</span>
                        </div>
                      </template>
                      <template v-slot:top>
                        <v-toolbar>
                          <v-spacer></v-spacer>
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                icon
                                x-large
                                v-on="on"
                                @click="newestrategia"
                                v-scroll-to="'#containerc'"
                              >
                                <v-icon color="primary">add</v-icon>
                              </v-btn>
                            </template>
                            <span>Agregar</span>
                          </v-tooltip>
                        </v-toolbar>
                      </template>
                      <template v-slot:[`item.action`]="{ item }">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-icon
                              v-on="on"
                              small
                              class="mr-2"
                              @click="grideditestrategia(item)"
                              v-scroll-to="'#containerc'"
                              >edit</v-icon
                            >
                          </template>
                          <span>Editar</span>
                        </v-tooltip>
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-icon
                              v-on="on"
                              small
                              class="mr-2"
                              v-show="item.eliminar"
                              @click="eliminarestrategia(item)"
                              >mdi-delete</v-icon
                            >
                          </template>
                          <span>Eliminar</span>
                        </v-tooltip>
                      </template>
                    </v-data-table>
                    <v-divider></v-divider>
                  </v-flex>
                  <v-card
                    v-show="frameestrategia"
                    id="containerc"
                    ref="containerc"
                  >
                    <v-card-title>Edición de estrategia</v-card-title>
                    <v-card-text>
                      <v-flex row wrap>
                        <v-flex sm12 xs12>
                          <v-textarea
                            v-model="nombreestrategia"
                            label="Nombre: *"
                            v-validate="'required|max:300'"
                            :counter="300"
                            data-vv-name="estrategia"
                            :error-messages="errors.collect('estrategia')"
                          ></v-textarea>
                        </v-flex>
                        <v-flex sm12 xs12>
                          <v-radio-group
                            row
                            v-validate="'required'"
                            label="Activo: *"
                            v-model="estrategia.activo"
                          >
                            <v-radio label="Si" :value="true"></v-radio>
                            <v-radio label="No" :value="false"></v-radio>
                          </v-radio-group>
                        </v-flex>
                      </v-flex>
                    </v-card-text>
                    <v-card-actions>
                      <br />
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            class="mx-1"
                            v-on="on"
                            color="blue darken-1"
                            @click="cerrarestrategia"
                            v-scroll-to="'#containerd'"
                          >
                            <div class="text-white">Cancelar</div>
                          </v-btn>
                        </template>
                        <span>Cancelar</span>
                      </v-tooltip>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            class="mx-1"
                            v-on="on"
                            color="blue darken-1"
                            @click="guardarestrategia"
                          >
                            <div class="text-white">Guardar</div>
                          </v-btn>
                        </template>
                        <span>Guardar</span>
                      </v-tooltip>
                    </v-card-actions>
                  </v-card>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title
          >Confirmar eliminación</v-card-title
        >
        <v-card-text>
          <br />
          Se procederá a realizar la eliminación definitiva del plan nacional:
          {{ nacional.nombre }}, ¿confirma la ejecución de esta operación?.
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">Cancelar</v-btn>
          <v-btn color="primary" text @click="eliminarexistente">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snack"
      :timeout="timeoutsnak"
      top
      :color="MesaggeInfo.color"
    >
      {{ this.MesaggeInfo.codigoRespuesta }}
      {{ this.MesaggeInfo.mensajeRespuesta }}
      <v-btn text @click="functionalert">{{ buttontext }} </v-btn>
      <v-btn text v-show="snackalert" @click="cancelsave">Cancelar</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { scroller } from "vue-scrollto/src/scrollTo";
import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
import { ErrorBag } from 'vee-validate';
import { quillEditor } from 'vue-quill-editor'
import Counter from "../../components/global/counter.js";
import Quill from 'quill';
var Delta = Quill.import('delta');
Quill.register('modules/counter', Counter);


export default {
  name: "adminnacionales",
  data() {
    return {
      //Datos de las personas
      items: [],
      estrategias: [],
      estrategia: {},
      dialog: false,
      buscanacional: "",
      nacional: {},
      type: "hex",
      sector: null,
      nombreestrategia: "",
      indexestrategia: 0,
      entidad: null,
      fileimagen: null,
      fileaprobado: null,
      baseimagen: null,
      basearchivo: null,
      framenacional: false,
      frameestrategia: false,
      editarnacional: false,
      headernacionales: [
        {
          text: "Nombre",
          value: "nombre",
          align: "left",
          width: "30%",
        },
        {
          text: "Descripción",
          value: "descripcion",
          align: "left",
        },
        {
          text: "Entidad",
          value: "identidadNavigation.nombre",
          align: "left",
          width: "20%",
        },
        { text: "Acción", value: "action", sortable: false, width: 100 },
      ],
      headerestrategia: [
        {
          text: "Nombre",
          value: "nombre",
          align: "left",
        },
        {
          text: "Activo",
          value: "activo",
          align: "left",
          width: 100,
        },
        { text: "Acción", value: "action", sortable: false, width: 100 },
      ],
      exportable: {
        ID: "idnacional",
        Nombre: "nombre",
        Descripcion: "descripcion",
        Objetivo: "objetivo",
        Especificos: "especificos",
        Inicio: "inicio",
        Fin: "fin",
        IdEntidad: "identidad",
        Entidad: "IdentidadNavigation.nombre",
        Creación: "fechacreacion",
        Modificación: "fechamodificacion",
        Usuario: "usuariomodificacion",
      },

      //elementos del fomrulario
      buttonguardarestado: false,
      buttonfinalizarestado: false,
      loading: false,

      //campos del cuadro de dialog de mensajes
      snack: false,
      snackalert: false,
      MesaggeInfo: [{ codigoRespuesta: "", color: "", mensajeRespuesta: "" }],
      timeoutsnak: 4000,
      buttontext: "Cerrar",

      //Validacion de campos
      dictionary: {
        custom: {
          nombrefuncionario: {
            required: () => "El nombre del plan nacional es obligatorio",
            alpha_spaces: "El nombre del plan nacional no es válido",
            max: "Está superando el límite de caracteres",
          },
          descripcion: {
            required: () => "La descripción del plan nacional es obligatoria",
            max: "Está superando el límite de caracteres",
          },
          objetivo: {
            required: () => "El objetivo del plan nacional es obligatorio",
            max: "Está superando el límite de caracteres",
          },
          especificos: {
            required: () =>
              "Los objetivos específicos del plan nacional son obligatorios",
            max: "xxxx Está superando el límite de caracteres",
          },
          agnoinicio: {
            required: () => "El año de inicio es obligatorio",
          },
          sector: {
            required: () => "El sector responsable es obligatorio",
          },
          entidad: {
            required: () => "La entidad responsable es obligatoria",
          },
          color: {
            required: () => "El color es obligatorio",
          },
          agnofin: {
            required: () => "El año fin es obligatorio",
          },
          estrategia: {
            required: () => "El nombre de la estrategia es obligatorio",
          },
        },
      },
      filearchivo: {},
      //Editor
      quill: null,
      editorOptions: {
        theme: 'snow',
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline','strike'],
              [{ list: 'ordered' }, { list: 'bullet' }],
               [{ 'indent': '-1'}, { 'indent': '+1' }],
            ],
          },
          counter: {
            container: '#counter',
            controlContainer: '#objetivosespecificos',
            unit: 'letra',
            max: 8000
          },
          clipboard: {
            matchers: [
              [ Node.ELEMENT_NODE, function(node, delta) {
                return delta.compose(new Delta().retain(delta.length(), 
                { 
                   align: "justify",
                  link: false,
                  color: false,
                  size:"10px",
                  header: false
                }
                ));
                }
              ] 
            ]
          }
        },
        placeholder: ''
      }
    };
  },
  components: {
    quillEditor
  },
  methods: {
    ...mapActions([
      "get_nacionales",
      "get_nacional",
      "get_nacionalarchivo",
      "get_nacionalimagen",
      "post_nacional",
      "put_nacional",
      "delete_nacional",
      "get_sectores",
      "get_entidadesbysector",
    ]),
    onEditorReady(quill) {
        quill.format('align', 'justify');
    },
    onEditorChange({ quill }) {
        quill.getModule('counter').update();
    },
    onaprobadochange() {
      let file = this.filearchivo;
      this.nacional.nombrearchivo = file.name;
      let reader = new FileReader();
      reader.onload = () => {
        this.basearchivo = reader.result;        
      };
      reader.readAsDataURL(file);
    },
    onimagechange() {
      let file = this.fileimagen;      
      let reader = new FileReader();
      reader.onload = () => {
        this.baseimagen = reader.result;        
      };
      reader.readAsDataURL(file);
    },
    salvarexistente() {
      this.loading = true;
      this.put_nacional({
        data: this.nacional,
      });
    },
    salvarnuevo() {
      this.loading = true;
      this.post_nacional({
        data: this.nacional,
      });
    },
    eliminarexistente() {
      this.loading = true;
      this.delete_nacional({
        params: { idnacional: this.nacional.idnacional },
      });
    },
    eliminarestrategia(item) {      
      let index = this.estrategias.indexOf(item);
      this.estrategias.splice(index, 1);
    },
    cancelsave() {
      this.snackalert = false;
      this.snack = false;
      this.buttontext = "Cerrar";
      this.timeoutsnak = 4000;
    },
    descargarsoporte() {      
      const a = document.createElement("a");
      a.style.display = "none";
      document.body.appendChild(a);
      a.href = this.basearchivo;
      a.setAttribute("download", this.nacional.nombrearchivo);
      a.click();
      window.URL.revokeObjectURL(a.href);
      document.body.removeChild(a);
    },
    guardarestrategia() {
      this.$validator.validate("estrategia").then((result) => {
        if (!result) {
          ///este console lo vamos a dejar para ver los posibles error de validación
          this.snack = true;
          this.snackalert = false;
          this.buttontext = "Cerrar";
          this.timeoutsnak = 4000;
          let Errores = "";
          this.$validator.errors.items.forEach((element) => {
            Errores = Errores + "( " + element.msg + " ), ";
          });
          this.MesaggeInfo.mensajeRespuesta =
            "La validación del formulario contiene errores " + Errores;
          this.MesaggeInfo.color = "infovue";
          return;
        } else {
          this.estrategia.nombre = this.nombreestrategia;
          if (this.estrategias === undefined) {
            this.estrategias = [];
          }
          if (this.nuevaestrategia === true) {
            this.estrategias.push(this.estrategia);
          } else {
            this.estrategias[
              this.indexestrategia
            ].nombre = this.nombreestrategia;
            this.estrategias[
              this.indexestrategia
            ].activo = this.estrategia.activo;
          }
          this.frameestrategia = false;
          const firstScrollTo = scroller();
          firstScrollTo("#containerd");
        }
      });
    },
    preventguardar() {
      this.$validator.validateAll("form-1").then((result) => {
        if (!result || this.$refs.objetivosespecificos.quill.root.innerHTML ==='<p class="ql-align-justify"><br></p>' || this.$refs.objetivosespecificos.quill.root.innerHTML.length > this.$refs.objetivosespecificos.quill.options.modules.counter.max) {          
          this.snack = true;
          this.snackalert = false;
          this.buttontext = "Cerrar";
          this.timeoutsnak = 4000;
          let Errores = "";
          
          let bag = new ErrorBag();
          bag = this.errors;
          if(bag.first('objetivosespecificos', 'form-1') !== undefined)
            bag.removeById(bag.first('objetivosespecificos', 'form-1').id);

          if( this.$refs.objetivosespecificos.quill.root.innerHTML ==='<p class="ql-align-justify"><br></p>' && bag.first('objetivosespecificos', 'form-1') == undefined)
          {
            bag.add({
                scope: 'form-1',
                field: 'objetivosespecificos',
                msg: 'Los objetivos especificos son requeridos'
            });
          }

          if( this.$refs.objetivosespecificos.quill.root.innerHTML.length > this.$refs.objetivosespecificos.quill.options.modules.counter.max  && bag.first('objetivosespecificos', 'form-1') == undefined)
          {
            bag.add({
                scope: 'form-1',
                field: 'objetivosespecificos',
                msg: 'Está superando el límite de caracteres'
            });
          }

          this.$validator.errors.items.forEach((element) => {
            Errores = Errores + "( " + element.msg + " ), ";
          });
          this.MesaggeInfo.mensajeRespuesta =
            "La validación del formulario contiene errores " + Errores;
          this.MesaggeInfo.color = "infovue";
          return;
        } else {          
          this.nacional.imagen = this.baseimagen;
          this.nacional.archivo = this.basearchivo;
          this.nacional.estrategiaNacional = this.estrategias;
          this.nacional.identidad = this.entidad.identidad;
          if (this.editarnacional === false) {
            this.salvarnuevo();
          } else {
            this.salvarexistente();
          }
        }
      });
    },
    cerrarrollocal() {
      this.framenacional = false;
      this.editarnacional = false;
    },
    cerrarestrategia() {
      this.frameestrategia = false;
    },
    grideditestrategia(item) {
      this.frameestrategia = true;
      this.nuevaestrategia = false;
      this.estrategia = Object.assign({}, item);
      this.indexestrategia = this.estrategias.indexOf(item);
    },
    grideditnacional(item) {
      this.framenacional = true;
      this.editarnacional = true;
      this.fileimagen= null;
      this.filearchivo = null;
      this.baseimagen= null;
      this.basearchivo = null;
      this.get_nacional({ params: { idnacional: item.idnacional } });
    },
    newpersona() {
      this.editarnacional = false;
      this.framenacional = true;
      this.entidad = null;
      this.sector = null;
      this.nacional = {
        nombre: "",
        idnacional: 0,
        descripcion: "",
        color: "#000000",
      };
    },
    newestrategia() {
      this.frameestrategia = true;
      this.estrategia = {
        nombre: "",
        idestrategia: 0,
        eliminar: true,
        activo: true,
      };
      this.nuevaestrategia = true;
    },
    eliminarnacional(item) {
      this.dialog = true;
      this.nacional = Object.assign({}, item);
    },
    functionalert() {
      if (this.buttontext == "cerrar") {
        this.snack = false;
      }
      if (this.buttontext == "aceptar") {
        this.snack = false;
        this.snackalert = false;
        this.timeoutsnak = 4000;
        this.buttontext == "cerrar";
        this.guardarrollocal();
      }
    },
  },
  created() {
    this.get_sectores();
    this.get_nacionales();
  },
  $_veeValidate: {
    validator: "new",
  },
  mounted() {
    this.$validator.localize("es", this.dictionary);
  },
  computed: {
    ...mapGetters([
      "gpersonas",
      "gentidades",
      "groles",
      "gtipodocumentos",
      "gnacionales",
      "gnacionalarchivo",
      "gnacionalimagen",
      "gsectores",
      "gnacional",
    ]),
    ...mapGetters("mensaje", ["ginformation", "gnodata", "gnosearch"]),
    color: {
      get() {
        return this[this.type];
      },
      set(v) {
        this[this.type] = v;
      },
    },
    itemsporpagina() {
      if (!isNaN(this.itemsPerPageSopCuan)) return this.itemsPerPageSopCuan;
      else return 1;
    },
    itemsporpagina2() {
      if (!isNaN(this.itemsPerPageSopCuan2)) return this.itemsPerPageSopCuan2;
      else return 1;
    },
    editor() {
      return this.$refs.objetivosespecificos.quill
    }
  },
  watch: {
    gnacional: function () {
      this.nacional = this.gnacional;
      this.color = this.nacional.color;
    },
    estrategia: function () {
      this.nombreestrategia = this.estrategia.nombre;
    },
    sector: function () {
      this.get_entidadesbysector({
        params: { idsector: this.sector.idsector },
      });
    },    
    gnacionalimagen: function () {
      this.nacional.imagen = this.gnacionalimagen;
      this.baseimagen = this.nacional.imagen;
    },
    gnacionalarchivo: function () {
      this.nacional.archivo = this.gnacionalarchivo;
      this.basearchivo = this.nacional.archivo;    
    },
    nacional: function () {
      this.get_nacionalarchivo({
        params: { idnacional: this.nacional.idnacional },
      });
      this.get_nacionalimagen({
        params: { idnacional: this.nacional.idnacional },
      });
      if (this.nacional.identidadNavigation !== undefined) {
        this.entidad = this.nacional.identidadNavigation;
        this.sector = this.gsectores.filter(
          (p) => p.idsector === this.nacional.identidadNavigation.idsector
        )[0];
      }      
      this.estrategias = [];
      if (this.nacional.estrategiaNacional != undefined) {
        this.nacional.estrategiaNacional.forEach((element) => {
          this.estrategias.push({
            idestrategianacional: element.idestrategianacional,
            nombre: element.nombre,
            eliminar: element.eliminar,
            idnacional: element.idnacional,
            activo: element.activo,
          });
        });
      }
    },
    gnacionales: function () {
      this.items = this.gnacionales;
    },
    ginformation() {
      if (this.loading) {
        this.MesaggeInfo = this.ginformation;
        this.snack = true;
        this.loading = false;
        if (this.MesaggeInfo.codigoRespuesta === "") {
          this.framenacional = false;
          this.dialog = false;
          const firstScrollTo = scroller();
          firstScrollTo("#containerb");
          setTimeout(() => {
            this.filearchivo = null;
            this.fileimagen = null;
            this.get_nacionales();
          }, 2000);
        }
      }
    },
  },
};
</script>
<style>

</style>